import axios from "axios";
import { toast } from "react-toastify";
import { globalConfig } from "./utils/config";


const getBaseUrl = () => {
  try {
    return globalConfig.getBaseUrl("BASE_AUTH_URL");
  } catch (error) {
    console.warn("Using default URL:", error.message);
    return "http://localhost:3000";
  }
};

let BASE_AUTH_URL = getBaseUrl();

const logout = () => {
  toast.warning("El token de autenticación ha expirado. Por favor, vuelva a iniciar sesión.");
  setTimeout(() => {
    localStorage.removeItem("token");
    window.location.href = "/";
  }, 4000);
};

export const httpWrapper = () => {
  const http = axios.create({
    baseURL: BASE_AUTH_URL,
  });

  
  http.interceptors.request.use(async (config) => {
 
    const currentBaseUrl = getBaseUrl();


    if (http.defaults.baseURL !== currentBaseUrl) {
      http.defaults.baseURL = currentBaseUrl;
    }

    const token = await localStorage.getItem("token");
    if (token) {
      if (!config.headers.common) {
        config.headers.common = {};
      }
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }
    return config;
  });

  http.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        const token = localStorage.getItem("token");
        if (token) {
          logout();
          localStorage.clear();
        }
      }
      return Promise.reject(error);
    }
  );
  return http;
};

export const http = httpWrapper();
export { BASE_AUTH_URL };
